/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_GeneralInputs */

const vi_shop_group_general = /** @type {(inputs: Shop_Group_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin chung`)
};

/**

* @param {Shop_Group_GeneralInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_general = /** @type {((inputs?: Shop_Group_GeneralInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_GeneralInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_general(inputs)
});